import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomNewItem_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string | undefined;
};

export const useRoomEditQuery = ({ hotelID, roomID }: Props) => {
	const { data } = useCustomSuspenseQuery(RoomNewItem_EditPage_Query, {
		variables: { hotelID, duplicateRoomID: roomID },
		fetchPolicy: "no-cache",
	});

	return data;
};
